import React, {useEffect, useState} from 'react';
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import {useParams} from "react-router-dom";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const DrawRoi = (props) => {
    const [myArr, setMyArr] = useState([])
    const [myItem, setMyItem] = useState([])
    const [sendData, setSendData] = useState({})
    const [lineType, setLineType] = useState(false)
    const params = useParams()
    var color_choices = [
        "#00FF47",
    ];

    var img = new Image();
    var rgb_color = color_choices[Math.floor(Math.random() * color_choices.length)]
    var opaque_color = 'rgba(0, 255, 71, 0.22)';

    var scaleFactor = 1;
    var scaleSpeed = 0.01;

    var points = [];
    var regions = [];
    var masterPoints = [];
    var masterColors = [];

    var showNormalized = false;
    var drawMode = "polygon";

    var modeMessage = document.querySelector('#mode');
    var coords = document.querySelector('#coords');

     
    useEffect((props) => {
  
    }, [])

    const sendDots = () => {

        let bigArr = []
        myArr?.map((item, index) => {
            item?.map(item2 => {
                return bigArr.push(item2)
            })
        })

        axios.post(API_PATH + "company/" + localStorage.getItem('id') + "/roi_analytics/create", {
            points: myArr.reduce((acc, item, index) => {
                return [
                    ...acc,
                    ...item.map((item2, index2) => {
                        return {
                            x: item2[0],
                            y: item2[1],
                            order_number: index2 + 1
                        }
                    })
                ]
            }, []),
            name: sendData?.name,
            attached_employee_id: sendData?.attached_employee_id,
            kassa_number: sendData?.kassa_number,
            roi_type: "string",
        }, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                toast.success("SUCCEESS")
            })
    }

    return (
        <div>
            <div className="camera-get-dots-header-new">
                <div>
                    <main>
                        <div className="flex">
                            <div className="left">

                                <div className="canvas-control">
                                    <canvas id="canvas"></canvas>
                                </div>
                            </div>
                            <div className="right">
                                <span style={{opacity: "0"}} id="x"></span>
                                <span style={{opacity: "0"}} id="y"></span>
                            </div>
                        </div>
                    </main>


                </div>
                <div className="center-item mb-20">
                    <div className="values-list">

                        <div className="tit-main d-flex justify-content-between  align-items-center ">
                            <h4 className="m-0">ROI list</h4>
                            <div>
                                <a href="" id="clear" className="widgetButton-clear text-decoration-none">Clear all
                                    points</a>
                            </div>
                        </div>
                        <div className="for-scrol-point">
                            {
                                myArr?.map((item0, index0) => {
                                    return item0?.map((item, index) => (
                                        <div className="values">
                                            <div className=" d-flex">
                                                <p><img src="/icon/greendot.svg" alt="..."/> Point {index + 1}</p>
                                            </div>
                                            <div className="d-flex">
                                                <p> X = {item[0]}  </p>
                                                <p className="ml-16"> Y ={item[1]} </p>
                                            </div>
                                        </div>
                                    ))
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="control-roi-boxs d-flex mt-3">
                <div className="row w-100">
                    <div className="col-md-3">
                        <div className="inputs-box">
                            <label className="font-family-medium">ROI name </label>
                            <input type="text" onChange={(e) => setSendData({...sendData, name: e.target.value})}/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="inputs-box">
                            <label className="font-family-medium">Assigned employee</label>
                            <input type="text"
                                   onChange={(e) => setSendData({...sendData, attached_employee_id: e.target.value})}/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="inputs-box">
                            <label className="font-family-medium">Номер кассы </label>
                            <input type="text"
                                   onChange={(e) => setSendData({...sendData, kassa_number: e.target.value})}/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="inputs-box">
                            <label className="font-family-medium">ROI type</label>
                            <FormControl>
                                <RadioGroup
                                    row
                                    value="roi"
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                >
                                    <FormControlLabel value="roi" control={<Radio/>} label="Employee ROI"/>
                                </RadioGroup>
                            </FormControl>
                        </div>
                    </div>
                </div>


            </div>
            <div className="control-btn-roi">
                <button type="submit" className="add-btn-video-roi" disabled={!myArr.length}
                        onClick={sendDots}>Сохранить
                </button>
                <button type="submit" className="cancel-btn ml-16" id="clear_btn" disabled={!myArr.length}>Отменить
                </button>
            </div>
        </div>
    );
};

export default DrawRoi;
